// extracted by mini-css-extract-plugin
export default {"containerTitle":"_1f5V","message":"_3TGU","formContainer":"_1Q73","form":"anV2","loading":"_2ylV","error":"_1Bdf","close":"_3HKZ"};